import React from "react";
import { svg } from "../../../../../Assets/svg";
import { Input, Modal } from "antd";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store";
import { BtnLoader } from "../../../../../Components/Components";
import { Field, Form, Formik } from "formik";
import { dispatchLoadValidation } from "../../../../validationSchema/common";
import { UpdateOrderDispatchPlaningLoadAPI } from "../../../../Redux/orders";
import { useParams } from "react-router-dom";

const AddDispatchLoadModal: React.FC<{
  visible: boolean;
  setIsModalVisible: (val: boolean) => void;
  setDispatchPlaning: (data: any) => void;
  isEditLoadData: any;
  setActiveKey: any;
  onSave?: (payload: any, callback: () => void) => void;
}> = ({
  visible,
  setIsModalVisible,
  setDispatchPlaning,
  isEditLoadData,
  setActiveKey,
  onSave,
}) => {
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const { addDispatchLoadsLoading } = useAppSelector(
    (state: RootState) => state.loading,
  );

  const onClose = React.useCallback(() => {
    setIsModalVisible(false);
  }, [setIsModalVisible]);

  const handleSave = (values: any) => {
    const payload = {
      order_id: id,
      load_count: values?.number_of_loads,
    };
    const successAddLoad = () => {
      setActiveKey("1");
      setIsModalVisible(false);
    };
    if (onSave) {
      onSave(payload, successAddLoad);
    } else {
      dispatch(UpdateOrderDispatchPlaningLoadAPI(payload, successAddLoad));
    }
  };

  return (
    <Modal
      title={
         <div className="text-center fs-4 fw-bolder lh-m">
          Number of Load Required
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
            disabled={addDispatchLoadsLoading}
          >
            CLOSE
          </button>
          <button
            type="submit"
            form="submitLoadForm"
            disabled={addDispatchLoadsLoading}
            className={`btn btn-lg min-w-130 btn-primary`}
            // onClick={handleSave}
          >
            {addDispatchLoadsLoading ? <BtnLoader /> : "SAVE"}
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <p className="fs-6 d-flex justify-content-center mt-3 text-center text-4a4a4a">
        Please enter the number of loads required to transport this order. If
        multiple vehicles are used, enter the total number accordingly. For
        example, if you use 2 different vehicles, please enter 2.
      </p>
      <Formik
        initialValues={{
          number_of_loads: isEditLoadData?.loads || 1,
        }}
        validationSchema={dispatchLoadValidation}
        onSubmit={handleSave}
        enableReinitialize
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched,
          setFieldValue,
        }: any) => {
          return (
            <Form id="submitLoadForm" onSubmit={handleSubmit}>
              <div className="row gy-3">
                <div className="col-md-12">
                  <div className="form-item">
                    <label className="custom-label mb-1 ff">
                      Number of Load / Number of Vehicle
                    </label>
                    <Field
                      name="number_of_loads"
                      className="form-control form-control-lg"
                      value={values?.number_of_loads}
                      // onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder={"Enter Number of Load / Number of Vehicle"}
                      as={Input}
                      onChange={(e: any) => {
                        setFieldValue("number_of_loads", e.target.value);
                      }}
                      min={0}
                      max={50}
                      onKeyDown={(e: any) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];

                        if (
                          allowedKeys.includes(e.key) ||
                          (e.key >= "0" && e.key <= "9")
                        ) {
                          return;
                        }

                        e.preventDefault();
                      }}
                    />
                    {errors?.number_of_loads && touched?.number_of_loads && (
                      <div className="text-danger fs-8">
                        {errors?.number_of_loads}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default AddDispatchLoadModal;
